/* TUZEX Black Friday – koleso šťastia (sekcia „TUZEX koleso šťastia“ v päte) */

(() => {
  /* ===== NASTAVENIA ===== */
  const rootEl = document.getElementById("tzx-koleso");
  let themeConfig = {};
  try { themeConfig = JSON.parse(rootEl?.dataset.config || "{}"); } catch (e) {}
  const CONFIG = Object.assign({
    logoUrl: "",
    autoOpen: false,                  // sám sa ukáže po pár sekundách (nastavenie v editore témy)
    delaySeconds: 6,
    exitIntent: true,
    hideDaysAfterClose: 2,
    oncePerDay: true,                 // automaticky najviac raz za deň, kým návštevník nezatočí
    activeFrom: null,
    activeTo: null,
    excludePaths: ["/cart", "/account", "/checkout", "/pages/kontaktujte-nas"],
    shopUrl: "/collections/all",
    autoApplyDiscount: true,
    saveCustomer: true,
    customerTags: "newsletter, koleso-stastia, black-friday",
    showBadge: true                   // po zatvorení ukázať pripomienku kódu v rohu
  }, themeConfig);

  /* ===== VÝHRY: poradie polí v smere hodín od ukazovateľa, weight = váha (šanca = weight / 150) ===== */
  const SEGMENTS = [
    { label: "LABUBU",         code: "FREELABUBU", weight: 8,  fill: "plum",  prize: "Labubu ako darček" },
    { label: "5 %",            code: "BLACK5",     weight: 20, fill: "tan",   prize: "Zľava 5 %" },
    { label: "10 %",           code: "BLACK10",    weight: 15, fill: "pine",  prize: "Zľava 10 %" },
    { label: "15 %",           code: "BLACK15",    weight: 8,  fill: "cream", prize: "Zľava 15 %" },
    { label: "5 €",            code: "BF5EURO",    weight: 20, fill: "pine",  prize: "Zľava 5 €" },
    { label: "10 €",           code: "BF10EURO",   weight: 15, fill: "cream", prize: "Zľava 10 €" },
    { label: "15 €",           code: "BF15EURO",   weight: 10, fill: "ember", prize: "Zľava 15 €" },
    { label: "DOPRAVA ZDARMA", code: "BLACKSHIP",  weight: 11, fill: "pine",  prize: "Doprava zdarma" },
    { label: "LABUBU",         code: "FREELABUBU", weight: 8,  fill: "plum",  prize: "Labubu ako darček" },
    { label: "5 %",            code: "BLACK5",     weight: 20, fill: "tan",   prize: "Zľava 5 %" },
    { label: "10 %",           code: "BLACK10",    weight: 15, fill: "pine",  prize: "Zľava 10 %" },
    { label: "20 %",           code: "BLACK15",    weight: 0,  fill: "cream", prize: "Zľava 20 %" },
  ];

  const root = rootEl;
  if (!root || root.dataset.ready) return;
  root.dataset.ready = "1";
  if (root.parentNode !== document.body) document.body.appendChild(root);

  const N = SEGMENTS.length, STEP = 360 / N;
  const TOTAL = SEGMENTS.reduce((s, x) => s + x.weight, 0);
  const DARK_TEXT = new Set(["cream", "tan"]);
  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const $ = (id) => document.getElementById(id);
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));
  const KEY = "tzx-koleso-v1";
  const store = {
    get() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } },
    set(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} },
  };

  function rand() {
    try { const a = new Uint32Array(1); crypto.getRandomValues(a); return a[0] / 4294967296; }
    catch (e) { return Math.random(); }
  }
  function pick() {
    const r = rand() * TOTAL;
    let acc = 0;
    for (let i = 0; i < N; i++) { acc += SEGMENTS[i].weight; if (r < acc) return i; }
    return SEGMENTS.findIndex((s) => s.weight > 0);
  }

  /* logo (ak sa nenačíta, ukáže sa text) */
  root.querySelectorAll("[data-tzx-logo]").forEach((img) => {
    img.addEventListener("error", () => {
      const t = document.createElement("span");
      t.className = "tzx-logo-text"; t.textContent = "TUZEX";
      img.replaceWith(t);
    }, { once: true });
    if (CONFIG.logoInvert) img.style.filter = "brightness(0) invert(1)";
    if (CONFIG.logoUrl) img.src = CONFIG.logoUrl; else img.dispatchEvent(new Event("error"));
  });

  /* koleso */
  const C = 250, R = 222;
  const pt = (a, r) => { const t = a * Math.PI / 180; return [(C + r * Math.sin(t)).toFixed(2), (C - r * Math.cos(t)).toFixed(2)]; };
  let wedges = "";
  SEGMENTS.forEach((s, i) => {
    const a = i * STEP;
    const [x0, y0] = pt(a - STEP / 2, R), [x1, y1] = pt(a + STEP / 2, R);
    const color = DARK_TEXT.has(s.fill) ? "var(--ink)" : "var(--bone)";
    const words = s.label.split(" ");
    const two = s.label.length > 8 && words.length > 1;
    const size = two ? 19 : (s.label.length > 4 ? 27 : 34);
    const y = C - (two ? 150 : 146);
    const text = two
      ? `<tspan x="${C}" dy="-0.58em">${words[0]}</tspan><tspan x="${C}" dy="1.16em">${words.slice(1).join(" ")}</tspan>`
      : s.label;
    wedges += `<g class="tzx-seg" data-i="${i}"><path d="M${C} ${C}L${x0} ${y0}A${R} ${R} 0 0 1 ${x1} ${y1}Z" style="fill:var(--${s.fill})"/>`
      + `<g transform="rotate(${a} ${C} ${C})"><text x="${C}" y="${y}" transform="rotate(-90 ${C} ${y})" text-anchor="middle" dominant-baseline="central" style="fill:${color};font-size:${size}px">${text}</text></g></g>`;
  });
  const disc = $("tzx-disc");
  disc.setAttribute("aria-label", "Koleso šťastia s 12 poľami: " + SEGMENTS.map((s) => s.label).join(", "));
  disc.innerHTML = `<defs><radialGradient id="tzx-shade" cx="50%" cy="50%" r="50%"><stop offset=".35" stop-color="#000" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity=".34"/></radialGradient></defs>`
    + wedges + `<circle cx="${C}" cy="${C}" r="${R}" fill="url(#tzx-shade)" pointer-events="none"/>`;
  let b1 = "", b2 = "";
  for (let i = 0; i < 24; i++) {
    const [x, y] = pt(i * 15 + 7.5, 236);
    const dot = `<circle class="halo" cx="${x}" cy="${y}" r="7.5"/><circle class="bulb" cx="${x}" cy="${y}" r="3.6"/>`;
    if (i % 2) b2 += dot; else b1 += dot;
  }
  $("tzx-rim").innerHTML =
    `<circle cx="${C}" cy="${C}" r="235.5" fill="none" stroke="#22160F" stroke-width="27"/>`
    + `<circle cx="${C}" cy="${C}" r="244" fill="none" stroke="#fff" stroke-opacity=".05" stroke-width="2"/>`
    + `<circle cx="${C}" cy="${C}" r="248.5" fill="none" stroke="#EF5A1E" stroke-opacity=".6" stroke-width="2"/>`
    + `<circle cx="${C}" cy="${C}" r="223" fill="none" stroke="#F3E6CC" stroke-opacity=".9" stroke-width="3"/>`
    + `<g class="b1">${b1}</g><g class="b2">${b2}</g>`;

  /* točenie */
  const wheel = $("tzx-wheel"), pin = $("tzx-pin");
  let rot = 0, raf = 0, pinAnim = null;
  const underPointer = (r) => Math.floor(((((-r) % 360) + 360) % 360 + STEP / 2) / STEP) % N;
  function flick() {
    if (!pin.animate) return;
    if (pinAnim) pinAnim.cancel();
    pinAnim = pin.animate([
      { transform: "translateX(-50%) rotate(0deg)" },
      { transform: "translateX(-50%) rotate(-24deg)", offset: 0.3 },
      { transform: "translateX(-50%) rotate(0deg)" },
    ], { duration: 150, easing: "ease-out" });
  }
  function spinTo(k) {
    const jitter = (rand() * 2 - 1) * (STEP / 2 - 4);
    const target = (((-k * STEP + jitter) % 360) + 360) % 360;
    const cur = ((rot % 360) + 360) % 360;
    let delta = target - cur; if (delta < 0) delta += 360;
    const start = rot, total = delta + 360 * (reduced ? 1 : 6);
    const dur = reduced ? 1200 : 5600, t0 = performance.now();
    let last = underPointer(rot);
    wheel.classList.add("tzx-spinning");
    return new Promise((res) => {
      const frame = (now) => {
        const t = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - t, 4);
        rot = start + total * e;
        disc.style.transform = `rotate(${rot}deg)`;
        const u = underPointer(rot);
        if (u !== last) { last = u; if (!reduced) flick(); }
        if (t < 1) raf = requestAnimationFrame(frame);
        else { wheel.classList.remove("tzx-spinning"); res(); }
      };
      raf = requestAnimationFrame(frame);
    });
  }

  /* stavy */
  const popup = $("tzx-popup"), form = $("tzx-form"), win = $("tzx-win"), spinBtn = $("tzx-spin");
  const fName = $("tzx-name"), fEmail = $("tzx-email"), fConsent = $("tzx-consent");
  const eName = $("tzx-e-name"), eEmail = $("tzx-e-email"), eConsent = $("tzx-e-consent");
  let opened = false, busy = false, lastFocus = null, prevOverflow = "";

  function setState(s) {
    const won = s === "won";
    popup.dataset.state = s;
    win.hidden = !won; form.hidden = won; $("tzx-sub").hidden = won; $("tzx-wheelWrap").hidden = won;
  }
  function setErr(input, el, msg) {
    el.textContent = msg || "";
    input.setAttribute("aria-invalid", msg ? "true" : "false");
  }
  function showWin(k) {
    const s = SEGMENTS[k];
    $("tzx-prize").textContent = s.prize;
    $("tzx-code").textContent = s.code;
    $("tzx-shop").href = "/discount/" + encodeURIComponent(s.code) + "?redirect=" + encodeURIComponent(CONFIG.shopUrl);
    applyDiscount(s.code);
    setState("won");
    $("tzx-live").textContent = `Vyhrali ste: ${s.prize}. Kód ${s.code}.`;
  }

  /* Shopify: kontakt a zľava */
  /* Uloženie kontaktu do Shopify (Zákazníci, súhlas s e-mail marketingom).
     Shopify chráni formulár proti spamu: ak si vyžiada overenie (captcha),
     odošleme ho normálne – návštevník overenie potvrdí a vráti sa späť na koleso. */
  function customerFields(name, email, seg) {
    return [
      ["form_type", "customer"],
      ["utf8", "✓"],
      ["contact[email]", email],
      ["contact[first_name]", name],
      ["contact[accepts_marketing]", "true"],
      ["contact[tags]", CONFIG.customerTags + ", vyhra-" + seg.code],
    ];
  }
  async function saveCustomer(name, email, seg) {
    if (!CONFIG.saveCustomer) return "off";
    const fd = new FormData();
    customerFields(name, email, seg).forEach(([k, v]) => fd.append(k, v));
    try {
      const ctrl = new AbortController();
      const t = setTimeout(() => ctrl.abort(), 8000);
      const res = await fetch("/contact#contact_form", { method: "POST", body: fd, credentials: "same-origin", signal: ctrl.signal });
      clearTimeout(t);
      const url = res.url || "";
      // Shopify po úspešnom uložení presmeruje na ...?customer_posted=true
      if (/customer_posted=true/.test(url)) return "ok";
      return /challenge/i.test(url) ? "challenge" : "unknown";
    } catch (e) {
      return "error";
    }
  }
  function submitNative(name, email, seg) {
    const back = location.pathname + "?koleso=spin";
    const f = document.getElementById("tzx-customer-form");
    if (f) {
      // formulár z témy – Shopify k nemu pri odoslaní pridá captcha token
      f.querySelector('[data-tzx-f="email"]').value = email;
      f.querySelector('[data-tzx-f="name"]').value = name;
      f.querySelector('[data-tzx-f="tags"]').value = CONFIG.customerTags + ", vyhra-" + seg.code;
      const ret = f.querySelector('input[name="return_to"]');
      if (ret) ret.value = back;
      if (f.requestSubmit) f.requestSubmit(); else f.submit();
      return;
    }
    const nf = document.createElement("form");
    nf.method = "post";
    nf.action = "/contact#contact_form";
    nf.acceptCharset = "UTF-8";
    nf.style.display = "none";
    [...customerFields(name, email, seg), ["return_to", back]].forEach(([k, v]) => {
      const i = document.createElement("input");
      i.type = "hidden"; i.name = k; i.value = v; nf.appendChild(i);
    });
    document.body.appendChild(nf);
    nf.submit();
  }

  function applyDiscount(code) {
    if (!CONFIG.autoApplyDiscount) return;
    fetch("/discount/" + encodeURIComponent(code), { credentials: "same-origin" }).catch(() => {});
  }

  /* Formulár kolesa je skutočný Shopify formulár na odber noviniek.
     Shopify k nemu pri odoslaní pridá ochranu proti spamu (captcha), uloží kontakt
     a vráti návštevníka späť (?koleso=spin) – tam sa koleso roztočí na vylosovanú výhru. */
  const messages = {
    name: "Zadajte meno aj priezvisko.",
    email: "Skontrolujte e-mail, napríklad jana@gmail.com.",
    consent: "Bez súhlasu nemôžeme koleso roztočiť.",
  };
  fName.addEventListener("invalid", (e) => { e.preventDefault(); setErr(fName, eName, messages.name); });
  fEmail.addEventListener("invalid", (e) => { e.preventDefault(); setErr(fEmail, eEmail, fEmail.value ? messages.email : "Zadajte e-mail."); });
  fConsent.addEventListener("invalid", (e) => { e.preventDefault(); setErr(fConsent, eConsent, messages.consent); });
  [fName, fEmail].forEach((i) => i.addEventListener("input", () => setErr(i, i === fName ? eName : eEmail)));
  fConsent.addEventListener("change", () => setErr(fConsent, eConsent));

  function validate() {
    [[fName, eName], [fEmail, eEmail], [fConsent, eConsent]].forEach(([i, el]) => setErr(i, el));
    const ok = form.checkValidity();
    if (!ok) { const bad = form.querySelector(":invalid"); if (bad) bad.focus(); }
    return ok;
  }

  function splitName() {
    const parts = fName.value.trim().split(/\s+/);
    const first = $("tzx-first"), last = $("tzx-last");
    if (first) first.value = parts.shift() || "";
    if (last) last.value = parts.join(" ");
  }

  function prepareWin() {
    const saved = store.get();
    if (saved.pendingSpin && saved.win && SEGMENTS[saved.win.i]) { splitName(); return saved.win.i; }
    const k = pick(), seg = SEGMENTS[k];
    saved.win = { i: k, code: seg.code, at: Date.now() };
    saved.pendingSpin = true;
    store.set(saved);
    const tags = $("tzx-tags");
    if (tags) tags.value = CONFIG.customerTags + ", vyhra-" + seg.code;
    const ret = form.querySelector('input[name="return_to"]');
    if (ret) ret.value = location.pathname + "?koleso=spin";
    splitName();
    return k;
  }

  // klik (aj Enter v poli) – pripraví výhru ešte predtým, než Shopify formulár odošle
  spinBtn.addEventListener("click", (e) => {
    if (busy) { e.preventDefault(); return; }
    if (!CONFIG.saveCustomer) return;
    if (!validate()) { e.preventDefault(); return; }
    const k = prepareWin();
    spinBtn.textContent = "Ukladáme…";
    // poistka: keby overenie neprešlo, po 15 s aspoň ukážeme výhru
    setTimeout(() => {
      if (document.visibilityState === "visible" && store.get().pendingSpin && !busy) runSpin(k);
    }, 15000);
  });

  form.addEventListener("submit", async (e) => {
    if (CONFIG.saveCustomer) {
      // odoslanie rieši Shopify (captcha + uloženie zákazníka)
      if (!store.get().pendingSpin) prepareWin();
      return;
    }
    e.preventDefault();
    if (busy || !validate()) return;
    const k = prepareWin();
    await runSpin(k);
  });

  async function runSpin(k) {
    const seg = SEGMENTS[k];
    const saved = store.get();
    delete saved.pendingSpin;
    store.set(saved);
    applyDiscount(seg.code);
    busy = true; spinBtn.disabled = true; spinBtn.textContent = "Koleso sa točí…";
    const box = wheel.getBoundingClientRect();
    if (box.top < 0 || box.bottom > innerHeight) wheel.scrollIntoView({ block: "center", behavior: reduced ? "auto" : "smooth" });
    await spinTo(k);
    disc.querySelector(`.tzx-seg[data-i="${k}"]`).classList.add("tzx-hit");
    wheel.classList.add("tzx-won");
    await wait(reduced ? 300 : 1300);
    busy = false;
    if (!opened) return;
    showWin(k);
    popup.scrollTop = 0;
    $("tzx-copy").focus({ preventScroll: true });
  }

  let copyT = 0;
  $("tzx-copy").addEventListener("click", () => {
    const code = $("tzx-code").textContent, lbl = $("tzx-copyLabel");
    applyDiscount(code);
    const done = (msg) => { lbl.textContent = msg; clearTimeout(copyT); copyT = setTimeout(() => (lbl.textContent = "Skopírovať kód"), 2400); };
    const selectCode = () => {
      const r = document.createRange(); r.selectNodeContents($("tzx-code"));
      const sel = getSelection(); sel.removeAllRanges(); sel.addRange(r);
      done("Kód je označený, skopírujte ho");
    };
    try { navigator.clipboard.writeText(code).then(() => done("Kód je skopírovaný"), selectCode); }
    catch (e) { selectCode(); }
  });

  /* pripomienka kódu po zatvorení */
  const badge = document.getElementById("tzx-badge");
  if (badge && badge.parentNode !== document.body) document.body.appendChild(badge);
  const BADGE_KEY = "tzx-koleso-badge-off";
  function campaignActive() {
    const now = Date.now();
    if (CONFIG.activeFrom && now < Date.parse(CONFIG.activeFrom)) return false;
    if (CONFIG.activeTo && now > Date.parse(CONFIG.activeTo)) return false;
    return true;
  }
  function badgeOff() { try { return sessionStorage.getItem(BADGE_KEY) === "1"; } catch (e) { return false; } }
  function renderBadge() {
    if (!badge) return;
    const s = store.get();
    const won = s.win && SEGMENTS[s.win.i];
    const show = CONFIG.showBadge && !opened && campaignActive() && !badgeOff() && (won || s.closedAt)
      && !location.pathname.startsWith("/checkout");
    if (!show) { badge.classList.remove("tzx-badge--in"); badge.hidden = true; return; }
    badge.querySelector("[data-tzx-badge-k]").textContent = won ? "Vaša výhra · kód" : "Black Friday";
    badge.querySelector("[data-tzx-badge-v]").textContent = won ? s.win.code : "Zatočiť kolesom";
    badge.querySelector(".tzx-badge-open").setAttribute("aria-label", won ? "Zobraziť váš zľavový kód " + s.win.code : "Otvoriť koleso šťastia");
    badge.hidden = false;
    requestAnimationFrame(() => badge.classList.add("tzx-badge--in"));
  }
  if (badge) {
    badge.querySelector(".tzx-badge-open").addEventListener("click", () => open());
    badge.querySelector(".tzx-badge-x").addEventListener("click", () => {
      try { sessionStorage.setItem(BADGE_KEY, "1"); } catch (e) {}
      renderBadge();
    });
  }

  /* otvorenie a zatvorenie */
  function open() {
    if (opened) return;
    opened = true;
    lastFocus = document.activeElement;
    const s = store.get();
    if (s.win && SEGMENTS[s.win.i] && s.pendingSpin) { setState("form"); setTimeout(() => runSpin(s.win.i), 450); }
    else if (s.win && SEGMENTS[s.win.i]) showWin(s.win.i); else setState("form");
    root.hidden = false;
    requestAnimationFrame(() => root.classList.add("tzx-open"));
    prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = "hidden";
    popup.focus({ preventScroll: true });
    sizeSparks(); startSparks();
    renderBadge();
  }
  function close() {
    if (!opened) return;
    opened = false;
    root.classList.remove("tzx-open");
    setTimeout(() => { if (!opened) root.hidden = true; }, reduced ? 0 : 300);
    document.documentElement.style.overflow = prevOverflow;
    const s = store.get();
    if (!s.win) { s.closedAt = Date.now(); store.set(s); }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    try { sessionStorage.removeItem(BADGE_KEY); } catch (e) {}
    setTimeout(renderBadge, reduced ? 0 : 320);
  }
  function reset() {
    store.set({});
    cancelAnimationFrame(raf); busy = false;
    wheel.classList.remove("tzx-won", "tzx-spinning");
    disc.querySelectorAll(".tzx-hit").forEach((g) => g.classList.remove("tzx-hit"));
    form.reset(); [[fName, eName], [fEmail, eEmail], [fConsent, eConsent]].forEach(([i, el]) => setErr(i, el));
    spinBtn.disabled = false; spinBtn.textContent = "Zatočiť kolesom";
    setState("form");
    renderBadge();
  }
  $("tzx-close").addEventListener("click", close);
  root.addEventListener("click", (e) => { if (e.target === root) close(); });
  root.addEventListener("keydown", (e) => {
    if (e.key === "Escape") { close(); return; }
    if (e.key !== "Tab") return;
    const f = [...popup.querySelectorAll("button,a[href],input")].filter((el) => !el.disabled && el.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === popup)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  document.addEventListener("click", (e) => {
    const t = e.target.closest && e.target.closest("[data-tzx-koleso]");
    if (t) { e.preventDefault(); open(); }
  });
  window.TuzexKoleso = { open, close, reset };

  /* iskry */
  const cv = $("tzx-sparks"), ctx = cv.getContext && cv.getContext("2d");
  let W = 0, H = 0, sparksOn = false;
  const parts = [];
  function sizeSparks() {
    if (!ctx) return;
    const r = popup.getBoundingClientRect(), dpr = Math.min(2, devicePixelRatio || 1);
    W = r.width; H = Math.max(r.height, popup.scrollHeight);
    cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  function spawn(p, anywhere) {
    p.x = W * Math.pow(rand(), 1.5);
    p.y = anywhere ? rand() * H : H + rand() * 30;
    p.vy = -(0.18 + rand() * 0.5); p.vx = (rand() - 0.35) * 0.3;
    p.r = 0.6 + rand() * 1.5; p.life = anywhere ? rand() * 300 : 0; p.max = 380 + rand() * 520;
    return p;
  }
  function draw() {
    if (!opened) { sparksOn = false; return; }
    ctx.clearRect(0, 0, W, H);
    ctx.shadowColor = "rgba(255,120,40,.9)"; ctx.shadowBlur = 6;
    for (const p of parts) {
      p.life++; p.y += p.vy; p.x += p.vx + Math.sin((p.life + p.r * 90) / 55) * 0.18;
      const a = Math.sin(Math.PI * Math.min(1, p.life / p.max));
      ctx.fillStyle = `rgba(255,${(130 + p.r * 40) | 0},60,${(a * 0.85).toFixed(3)})`;
      ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283); ctx.fill();
      if (p.life > p.max || p.y < -12) spawn(p, false);
    }
    requestAnimationFrame(draw);
  }
  function startSparks() {
    if (!ctx || reduced || sparksOn) return;
    if (!parts.length) for (let i = 0; i < 34; i++) parts.push(spawn({}, true));
    sparksOn = true; requestAnimationFrame(draw);
  }
  if (window.ResizeObserver) new ResizeObserver(() => opened && sizeSparks()).observe(popup);

  /* kedy sa popup ukáže */
  const param = new URLSearchParams(location.search).get("koleso");
  if (param === "reset") store.set({});
  const posted = new URLSearchParams(location.search).get("customer_posted") === "true";
  const forced = param === "1" || param === "reset" || ((param === "spin" || posted) && !!store.get().pendingSpin);
  if (param === "spin") { try { history.replaceState(null, "", location.pathname); } catch (e) {} }
  function today() { const d = new Date(); return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate(); }
  function autoOpen() {
    if (opened || !eligible()) return;
    const s = store.get(); s.shownDay = today(); store.set(s);
    open();
  }
  function eligible() {
    if (forced) return true;
    const s = store.get(), now = Date.now();
    if (s.win) return false;
    if (CONFIG.oncePerDay) { if (s.shownDay === today()) return false; }
    else if (s.closedAt && now - s.closedAt < CONFIG.hideDaysAfterClose * 864e5) return false;
    if (CONFIG.activeFrom && now < Date.parse(CONFIG.activeFrom)) return false;
    if (CONFIG.activeTo && now > Date.parse(CONFIG.activeTo)) return false;
    if (CONFIG.excludePaths.some((p) => location.pathname.includes(p))) return false;
    return true;
  }
  renderBadge();
  if ((CONFIG.autoOpen || forced) && eligible()) {
    const timer = setTimeout(forced ? open : autoOpen, forced ? 300 : CONFIG.delaySeconds * 1000);
    if (CONFIG.exitIntent && !forced && matchMedia("(pointer: fine)").matches) {
      const onOut = (e) => {
        if (!e.relatedTarget && e.clientY <= 0) { clearTimeout(timer); document.removeEventListener("mouseout", onOut); autoOpen(); }
      };
      document.addEventListener("mouseout", onOut);
    }
  }
})();
